import React from 'react'
import { motion } from 'framer-motion'
import { usePublicContent } from '../hooks/usePublicContent'
import { AboutContent } from '../types/content'

const WhatWeDoIntro: React.FC = () => {
  const { content } = usePublicContent('about')
  const aboutData = content?.data as AboutContent

  return (
    <section id="about" className="relative overflow-hidden py-12 sm:py-16">
      {/* Rich gradient background - matching About section */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute inset-0"
          style={{
            background: `linear-gradient(to bottom right, 
              color-mix(in srgb, var(--color-primary) 90%, transparent), 
              #171717, 
              color-mix(in srgb, var(--color-secondary) 80%, transparent))`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-neutral-900 via-transparent to-neutral-900/70" />
        <div className="absolute inset-0 bg-pattern opacity-5" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-black/30" />
        <div
          className="absolute top-0 left-1/4 w-96 h-96 blur-3xl rounded-full opacity-30"
          style={{
            background: `color-mix(in srgb, var(--color-primary) 20%, transparent)`
          }}
        />
        <div
          className="absolute bottom-0 right-1/4 w-96 h-96 blur-3xl rounded-full opacity-30"
          style={{
            background: `color-mix(in srgb, var(--color-secondary) 20%, transparent)`
          }}
        />
      </div>

      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.7 }}
          className="text-center max-w-3xl mx-auto"
        >
          <h2 className="font-bold mb-4 font-alt text-white" style={{ fontSize: 'clamp(32px, 4vw, 48px)' }}>
            {aboutData?.title || 'What We Do'}
          </h2>
          <p className="text-neutral-300 max-w-3xl mx-auto text-lg">
            {aboutData?.description ||
              'We curate exceptional live music experiences at prestigious venues across the country, ensuring every performance exceeds expectations.'}
          </p>
        </motion.div>
      </div>
    </section>
  )
}

export default WhatWeDoIntro
